"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountTypes = void 0;
var AccountTypes;
(function (AccountTypes) {
    /* Canada */
    AccountTypes["PERSONAL"] = "PERSONAL";
    AccountTypes["RRSP"] = "RRSP";
    AccountTypes["TFSA"] = "TFSA";
    AccountTypes["FHSA"] = "FHSA";
    AccountTypes["RESP"] = "RESP";
    AccountTypes["RESP_SINGLE"] = "RESP_SINGLE";
    AccountTypes["RESP_FAMILY"] = "RESP_FAMILY";
    AccountTypes["RESP_ADULT"] = "RESP_ADULT";
    AccountTypes["CORPORATE_CASH"] = "CORPORATE_CASH";
    AccountTypes["CORPORATE_TRUST"] = "CORPORATE_TRUST";
    AccountTypes["CORPORATE_ESTATE"] = "CORPORATE_ESTATE";
    AccountTypes["CORPORATE_CHARITY"] = "CORPORATE_CHARITY";
    AccountTypes["RRSP_SPOUSAL"] = "RRSP_SPOUSAL";
    AccountTypes["LIRA"] = "LIRA";
    AccountTypes["RRIF"] = "RRIF";
    AccountTypes["RIF_SPOUSAL"] = "RIF_SPOUSAL";
    AccountTypes["LIF"] = "LIF";
    AccountTypes["PRIF"] = "PRIF";
    AccountTypes["GRSP"] = "GRSP";
    AccountTypes["CASH_JOINT"] = "CASH_JOINT";
    AccountTypes["RESP_SINGLE_JOINT"] = "RESP_SINGLE_JOINT";
    AccountTypes["RESP_FAMILY_JOINT"] = "RESP_FAMILY_JOINT";
    AccountTypes["RDSP"] = "RDSP";
    AccountTypes["LRIF"] = "LRIF";
    AccountTypes["RLIF"] = "RLIF";
    AccountTypes["RLSP"] = "RLSP";
    AccountTypes["LRSP"] = "LRSP";
    /* United States of America */
    AccountTypes["USA_BROKERAGE"] = "USA_BROKERAGE";
    AccountTypes["USA_IRA"] = "USA_IRA";
    AccountTypes["USA_RO_IRA"] = "USA_RO_IRA";
    AccountTypes["USA_RT_IRA"] = "USA_RT_IRA";
    AccountTypes["USA_INH_IRA"] = "USA_INH_IRA";
    AccountTypes["USA_JT_WROS"] = "USA_JT_WROS";
    AccountTypes["USA_JT_TIC"] = "USA_JT_TIC";
    AccountTypes["USA_JT_CP"] = "USA_JT_CP";
    AccountTypes["USA_SEP_IRA"] = "USA_SEP_IRA";
    AccountTypes["USA_401K"] = "USA_401K";
    AccountTypes["USA_SOLO_401K"] = "USA_SOLO_401K";
    AccountTypes["USA_TRUST"] = "USA_TRUST";
    AccountTypes["USA_CORPORATE"] = "USA_CORPORATE";
    AccountTypes["USA_ESA_IRA"] = "USA_ESA_IRA";
    AccountTypes["USA_529"] = "USA_529";
    /* United Kingdom */
    AccountTypes["UK_BROKERAGE"] = "UK_BROKERAGE";
    AccountTypes["UK_CASH_ISA"] = "UK_CASH_ISA";
    AccountTypes["UK_SS_ISA"] = "UK_SS_ISA";
    AccountTypes["UK_JISA"] = "UK_JISA";
    AccountTypes["UK_PERSONAL_PENSION"] = "UK_PERSONAL_PENSION";
})(AccountTypes = exports.AccountTypes || (exports.AccountTypes = {}));
//# sourceMappingURL=accountTypeEnums.js.map